import { NgModule } from "@angular/core";
import {
  RouterModule,
} from "@angular/router";
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { environment } from "src/environments/environment";
import { routes, routesDsk } from "./services/routes/routes";

@NgModule({
  imports: [RouterModule.forRoot(environment.isMoblie ? routes : routesDsk)],
  exports: [RouterModule],
  providers: [{
    provide: HAMMER_GESTURE_CONFIG,
    useClass: HammerGestureConfig
  }]
})
export class AppRoutingModule {
}

